// @flow

import styled from 'styled-components';
import type { Theme } from '../../../types';

const IconWrapper = styled<any, Theme>('div')`
height: 0.75rem;
width: 0.75rem;
margin: auto;
font-size: 0;
`;

export default IconWrapper;
